@let currentLanguage = this.currentLanguage();

@let isFrench = currentLanguage === 'fr-CA';

<img class="logo" src="/images/logo.svg" width="76" height="76" alt="">

<div class="title" [class.fr]="isFrench">
  @if (isFrench) {
    <span>Suivez-nous sur<br/>les médias sociaux!</span>
  } @else {
    <span>Follow us on<br/>social media!</span>
  }
</div>

<div class="social">
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" rx="16" fill="#E31E38"/>
    <path
      d="M35.717 56V34.106h7.346l1.102-8.534h-8.448v-5.448c0-2.47.683-4.154 4.23-4.154l4.515-.002V8.334C43.682 8.233 41 8 37.88 8c-6.515 0-10.975 3.977-10.975 11.278v6.294h-7.368v8.534h7.368V56h8.812Z"
      fill="#FFF7E9"/>
  </svg>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" rx="16" fill="#E31E38"/>
    <path
      d="M31.819 15.364C22.4 15.364 15 22.764 15 32.182 15.001 41.6 22.401 49 31.819 49c9.418 0 16.818-7.4 16.818-16.818 0-9.418-7.4-16.818-16.818-16.818Zm0 26.909c-5.718 0-10.09-4.373-10.09-10.09 0-5.719 4.372-10.092 10.09-10.092s10.09 4.373 10.09 10.091c0 5.718-4.372 10.091-10.09 10.091ZM48.637 18.727a3.364 3.364 0 1 0 0-6.727 3.364 3.364 0 0 0 0 6.727Z"
      fill="#FFF7E9"/>
  </svg>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" rx="16" fill="#E31E38"/>
    <path
      d="M36.6979 28.2478L52.4819 10.2359H46.6562L34.0842 24.6483L22.9121 10.2358H8L26.5602 34.3578L9.70319 53.7644H15.3445L29.1739 37.9572L41.4567 53.7644H56L36.6979 28.2478ZM42.9529 48.9689L16.9346 14.8469H21.254L47.2723 48.9689H42.9529Z"
      fill="#FFF7E9"/>
  </svg>
</div>

<div class="link">
  @let qrCodeLinkEn = 'https://oon.gl/D6G7Sd';
  @let qrCodeLinkFr = 'https://oon.gl/p5uqvK';

  <svg class="arrow" width="96" height="180" viewBox="0 0 96 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40.946 179.96a7.327 7.327 0 0 0 1.524 0 4.319 4.319 0 0 0 2.552-1.081 4.764 4.764 0 0 0 1.312-3.083c.089-.602.177-1.205.248-1.772.177-1.152.337-2.286.479-3.385.283-2.232.567-4.376.833-6.414.478-4.076.85-7.726 1.099-10.81.478-6.149.425-9.959-.266-10.047-.691-.089-1.914 3.544-3.332 9.569-.71 3.012-1.472 6.627-2.252 10.632-.354 2.02-.762 4.147-1.152 6.362-.2 1.075-.396 2.173-.585 3.296a20.915 20.915 0 0 0-1.24-1.772c-1.649-2.464-4.698-6.291-9.147-12.848a156.807 156.807 0 0 1-15.952-29.717 116.622 116.622 0 0 1-6.63-23.674A103.7 103.7 0 0 1 7.09 91.713c-.109-4.734.093-9.47.603-14.176a98.915 98.915 0 0 1 2.783-14.177 88.009 88.009 0 0 1 5.07-13.733 80.98 80.98 0 0 1 16.59-23.568 90.368 90.368 0 0 1 10.635-8.86 87.35 87.35 0 0 1 11.256-6.646A86.054 86.054 0 0 1 75.12 3.13a97.71 97.71 0 0 1 15.19-1.772c1.9.144 3.811.055 5.69-.266a19.503 19.503 0 0 0-5.654-.94A75.797 75.797 0 0 0 74.64.79a84.265 84.265 0 0 0-22.334 6.645 89.524 89.524 0 0 0-12.053 6.556 90.808 90.808 0 0 0-11.521 9.002A84.725 84.725 0 0 0 10.51 47.501 92.137 92.137 0 0 0 4.84 61.907a100.467 100.467 0 0 0-3.208 14.956 100.717 100.717 0 0 0 .372 29.133 117.84 117.84 0 0 0 6.86 24.808 137.542 137.542 0 0 0 17.105 30.674 102.137 102.137 0 0 0 10.635 12.404l.443.408a159.499 159.499 0 0 0-25.063-1.046c-7.356.266-11.859 1.081-11.84 1.772 0 1.418 18.008 1.595 39.668 4.82l1.135.124Z"
      fill="#FFF7E9"/>
  </svg>

  <app-qrcode
    class="qr-code"
    variant="red"
    [content]="isFrench ? qrCodeLinkFr : qrCodeLinkEn"
    [size]="400"
  />
</div>

<div class="description">
  @if (isFrench) {
    <span>Soyez au courant de ce qui<br/> se passe chez BP</span>
  } @else {
    <span>Never miss out on our updates</span>
  }
</div>
